const __pimpl = Symbol.for('pimpl');

export default class {
	constructor(impl) {
		this[__pimpl] = impl;
	}

	get impl() {
		return this[__pimpl];
	}
}


// WEBPACK FOOTER //
// ./src/utils/pimpl.js